<template>
  <auth-shell>
    <div class="text-center">
      <img class="unauth-illustration" src="/img/ship-icon.svg" />
      <h4 class="auth-title">Unauthorized</h4>
      <p class="auth-body-text">
        If you believe you encountered this page in error, please let us
        know by emailing
        <a href="mailto:info@ashoreapp.com">info@ashoreapp.com</a>
      </p>
      <a href="/" class="auth-btn-primary mt-4">Log In</a>
      <a href="/forgot-password" class="auth-btn-ghost mt-3">Forgot My Password</a>
      <a href="/sign-up" class="auth-btn-ghost mt-3">Create an Account</a>
    </div>
  </auth-shell>
</template>

<script>
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
};
</script>

<style scoped>
.unauth-illustration {
  height: 100px;
  margin-bottom: 25px;
}
</style>
